import {Property} from "@/model/ThingModel";
import TransferParam from "./TransferParam";
import {DataType, IntSpec} from "./DataSpec";

export enum ProxyMode {
    STD_PROXY = "STD_PROXY",
    BIND_PROXY = "BIND_PROXY"
}

export default interface ParamProxy {
    name: string;
    identifier: string;
    mode: ProxyMode;
    order: number;
    required: boolean;
}

abstract class BaseParamProxy implements ParamProxy {
    name!: string
    identifier!: string
    mode!: ProxyMode
    order!: number
    required!: boolean
}


export type TransferParamBindProxy = ParamProxy

abstract class BaseParamBindProxy extends BaseParamProxy implements TransferParamBindProxy {
    readonly mode = ProxyMode.BIND_PROXY
}

export class ParamBindProxy extends BaseParamBindProxy {
    static of(prop: Property): ParamBindProxy {
        const proxy = new ParamBindProxy()
        proxy.identifier = prop.identifier
        proxy.name = prop.name
        return proxy
    }
}


export interface TransferParamStdProxy extends ParamProxy {
    param: TransferParam;
}

abstract class BaseParamStdProxy extends BaseParamProxy implements TransferParamStdProxy {
    readonly mode = ProxyMode.STD_PROXY
    param: TransferParam = {
        identifier: "",
        name: "",
        required: false,
        dataType: DataType.INT,
        dataSpecs: [new IntSpec()]
    }

    //@ts-ignore
    get identifier(): string {
        return this.param.identifier
    }

    //@ts-ignore
    get name(): string {
        return this.param.name
    }
}

export class ParamStdProxy extends BaseParamStdProxy {
}
